// Convert hex color to rgba with opacity
export const hexToRgba = (hex: string | undefined, opacity: number) => {
	if (!hex) return undefined;
	const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
	if (result) {
		const r = parseInt(result[1], 16);
		const g = parseInt(result[2], 16);
		const b = parseInt(result[3], 16);
		return `rgba(${r}, ${g}, ${b}, ${opacity})`;
	}
	return undefined;
};

// Determine if text should be dark or light based on background color
export const getTextColorForBackground = (hex: string | undefined) => {
	if (!hex) return 'text-gray-800';
	const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
	if (result) {
		const r = parseInt(result[1], 16);
		const g = parseInt(result[2], 16);
		const b = parseInt(result[3], 16);
		// Calculate luminance
		const luminance = (0.299 * r + 0.587 * g + 0.114 * b) / 255;
		return luminance > 0.5 ? 'text-gray-800' : 'text-white';
	}
	return 'text-gray-800';
};

// Check if a color is too light to be visible as a border
export const isColorTooLight = (hex: string | undefined) => {
	if (!hex) return false;
	const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
	if (result) {
		const r = parseInt(result[1], 16);
		const g = parseInt(result[2], 16);
		const b = parseInt(result[3], 16);
		// Calculate luminance - if it's very high (close to white), return true
		const luminance = (0.299 * r + 0.587 * g + 0.114 * b) / 255;
		return luminance > 0.9; // Colors with >90% luminance are too light
	}
	return false;
};